import React, { useState, useEffect } from "react";
import { size } from "lodash";

import certiIcons from "../../images/certiIcons.svg";
import NoDataFound from "../common/NoDataFound";
import ReadMore from "../ReadMore";

function CertificatesInfo(props) {
  const certis = props.data;

  const [showNoData, setShowNoData] = useState(true);
  const [isReadMore, setIsReadMore] = useState(false);
  const [isExpanded, setIsExpanded] = useState(false);

  useEffect(() => {
    if (size(certis) > 0) {
      setShowNoData(false);
    } else {
      setShowNoData(true);
    }
  }, [props.data]);

  return (
    <div className="card">
      <h3 className="">
        {/* <img src={certiIcons} alt="" className="company-info-icon mx-1" /> */}
        Company Approved Certificate
      </h3>
      <div className="company-service-inf">
        <div className="outer">
          <ul id="portfolio" className={isExpanded ? "readmore" : ""}>
            {!showNoData && !isReadMore &&
              certis.slice(0,8)
                .filter(
                  (value, index, self) =>
                    index ===
                    self.findIndex(
                      (t) => t.certificates.name === value.certificates.name
                    )
                )
                .map((val, k) => {
                  const capitalizeWords = (str) => {
                    return str
                      .toLowerCase()
                      .split(" ")
                      .map(
                        (word) => word.charAt(0).toUpperCase() + word.slice(1)
                      )
                      .join(" ");
                  };
                  return (
                    <li key={k}>
                      <i className="fa-solid fa-arrow-right"></i>
                      {capitalizeWords(val.certificates.name)}
                    </li>
                  );
                })}
                {!showNoData && isReadMore &&
              certis
                .filter(
                  (value, index, self) =>
                    index ===
                    self.findIndex(
                      (t) => t.certificates.name === value.certificates.name
                    )
                )
                .map((val, k) => {
                  const capitalizeWords = (str) => {
                    return str
                      .toLowerCase()
                      .split(" ")
                      .map(
                        (word) => word.charAt(0).toUpperCase() + word.slice(1)
                      )
                      .join(" ");
                  };
                  return (
                    <li key={k}>
                      <i className="fa-solid fa-arrow-right"></i>
                      {capitalizeWords(val.certificates.name)}
                    </li>
                  );
                })}

            <div>{showNoData && <NoDataFound />}</div>
          </ul>
          {!showNoData && (size(certis) > 8) ? (<ReadMore isReadMore={isReadMore} setIsReadMore={setIsReadMore} isExpanded={isExpanded} setIsExpanded={setIsExpanded}/>) : ""}
        </div>
      </div>
    </div>
  );
}

export default CertificatesInfo;